<template lang='pug'>
.product-tech-container(v-if='options.length')
    SectionPanel(:options="options")
</template>

<script>
import { getDataHierarchies } from '@custouch/proxy-use'
import SectionPanel from './components/Panel/SectionPanel'
export default {
    data(){
        return {
            options:[
                // {img:'https://oss.cloud.custouch.com/res/12911/产品荟萃.PNG',text:'产品荟萃',to:{ name: "levelPage", params: { section: "产品荟萃" } }},
                // {img:'https://oss.cloud.custouch.com/res/12912/行业应用.png',text:'行业应用',to:{ name: "industryApplication" }},
                // {img:'https://oss.cloud.custouch.com/res/12909/工业4.0封面图.JPG',text:'工业 4.0',to:{ name: "levelPage", params: { section: "工业 4.0" } }},
            ]
        }
    },
    components:{
        SectionPanel
    },
    async created(){
        const { DATA } = window.env
        const { module } = DATA
        const ret = await getDataHierarchies(module.productTech.id)
        if(ret.length){
            this.options = ret.reduce((pre,cur)=>{
                if(cur.id === module.productTech.hierarchies.Application){
                    pre.push(Object.assign({id: cur.id,text: cur.name, img: cur.detail.banner, to: {name: 'industryApplication'}}))
                }else{
                    pre.push(Object.assign({id: cur.id,text: cur.name, img: cur.detail.banner, to: {name: 'levelPage', params: {hId: cur.id}}}))
                }
                return pre
            },[])
        }

    }
}
</script>

<style scoped lang='less'>

.product-tech-container {
    padding: 1.2rem 0.8rem;
}
</style>